import { request } from '@/utils'
import { SubscriptionRule, SubscriptionPushConfig } from '@/types';

// 查询订阅规则列表
export const getSubscriptionList = async (data: any): Promise<any> => {
    return request.post('/crm/cdi/api/v1/subscribeRules/opportunities/search', {
      ...data,
    });
};

// 查询订阅历史列表
export const getSubscriptionHistoryList = async (data: any): Promise<any> => {
    return request.post('/crm/cdi/api/v1/subscribeRules/history/opportunities/search', {
      ...data,
    });
};


// 查询订阅渠道
export const queryBusinessOpportunityScribePush = async (): Promise<SubscriptionPushConfig> => {
    return request.post('/crm/cdi/api/v1/subscribeRules/queryBusinessOpportunityScribePush');
};

// 查询企业订阅规则
export const queryCorporationSubscribeRule = async (): Promise<any> => {
    return request.post('/crm/cdi/api/v1/subscribeRules/queryCorporationSubscribeRule');
};

// 查询关键词设置
export const queryKeywordSetting = async (): Promise<any> => {
    return request.post('/crm/cdi/api/v1/subscribeRules/queryKeywordSetting');
};

// 查询高级订阅规则
export const queryBusinessOpportunityScribeRule = async (data: any): Promise<SubscriptionRule> => {
    return request.post('/crm/cdi/api/v1/subscribeRules/queryBusinessOpportunityScribeRule', {
      ...data,
    });
};

// 更新订阅规则
export const updateSubscriptionRule = async (data: SubscriptionRule): Promise<any> => {
    return request.post('/crm/cdi/api/v1/subscribeRules/update', {
      ...data,
    });
};

// 查询品类
export const getCategories = async (): Promise<any> => {
  return request.get(
    '/crm/cdi/api/v1/categories?ctoken=05a221ec-d457-41a1-a358-be03c10da00d&type=1688_std_all&level=3&scene=PURCHASE'
  );
};

// 查询关键词
export const queryKeywords = async (): Promise<any> => {
  const res = await request.post(
    '/api/trantor/service/engine/execute/VEGETA$buyer_top_eight_search_terms',
    { params: { request: {} } }
  )
  return res.data || [];
};

// 查询ai关键词
export const queryKeywordsAi = async (): Promise<any> => {
  const res = await request.get(
    '/bcp/supplier/market/portal/aiKeywordList'
  )
  return res|| [];
};

// 新建订阅规则
export const createSubscriptionRule = async (data: any): Promise<any> => {
  return request.post(
    '/crm/cdi/api/v1/subscribeRules/createAccountSubscribeRule',
    {
      ...data,
    }
  );
};

export const submitSubscriptionRule = async (data: any): Promise<any> => {
  return request.post(
    '/crm/cdi/api/v1/subscribeRules/saveKeywordSetting',
    {
      ...data,
    }
  );
};

// 更新订阅规则
export const updateSubscribeRule = async (data: any): Promise<any> => {
  return request.post(
    '/crm/cdi/api/v1/subscribeRules/updateAccountSubscribeRule',
    {
      ...data,
    }
  );
};

// 删除订阅规则
export const deleteSubscribeRule = async (data: any): Promise<any> => {
  return request.post(
    '/crm/cdi/api/v1/subscribeRules/deleteSubscribeRule',
    {
      ...data,
    }
  );
};

// 查询是否主账号
export const queryIsMainAccount = async (data: any): Promise<any> => {
  return request.post(
    '/crm/cdi/api/v1/subscribeRules/isMainAccount',
    {
      ...data,
    }
  );
};

// 查询地区（城市）
export const getCityAreas = async (params?: { areaType?: string }): Promise<any> => {
  const areaType = params?.areaType || 'CITY';
  return request.get(
    `/crm/cdi/api/v1/areas?ctoken=cdaa0633-d61d-4561-b3ce-e43833cd24d5&areaType=${areaType}&type=CAIXIAO`
  );
};

export const getCityAreasSort = async (params?: { areaType?: string }): Promise<any> => {
  const areaType = params?.areaType || 'CITY';
  return request.get(
    `/crm/cdi/api/v1/areas/sorted?ctoken=cdaa0633-d61d-4561-b3ce-e43833cd24d5&areaType=${areaType}&type=CAIXIAO`
  );
};

// 通知/取消通知订阅渠道
export const updateBusinessOpportunityScribePush = async (data: any): Promise<any> => {
  return request.post(
    '/crm/cdi/api/v1/subscribeRules/updateBusinessOpportunityScribePush',
    {
      ...data,
    }
  );
};